import React from 'react';
import PropTypes from 'prop-types';
import { PrimaryButton } from '@huggg/react-components'
import { getBasePathname } from 'utilities/huggg';
import { Link } from 'react-router-dom'

const ChooseButton = props => {
  const { huggg } = props;

  return (
    <Link
      to={`${getBasePathname(huggg)}/choose`}
      style={{ width: '320px', marginTop: '8px', textDecoration: 'none' }}
    >
      <PrimaryButton label="GET STARTED" />
    </Link>
  );
};

ChooseButton.propTypes = {
  huggg: PropTypes.object.isRequired,
};

export default ChooseButton;
